module.exports = __webpack_public_path__ + "static/media/eth.73dabb37.png";